var video_viewer_default = {
  "video_player": "OKn4N",
  "videoOverlay": "_2i-Rh",
  "video_container": "_5OZBE"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
